/**
 * highlightLogic
 *
 * Reine, framework-freie Entscheidungslogik des roten Auswahl-Highlights (kein OSMD/Vue) – so
 * unit-testbar, ohne einen OSMD-Mock. Sub-Logik von {@link @/composables/osmd/useScoreHighlight}.
 */

/**
 * Zu färbende SVG-Elemente der ausgewählten Note innerhalb ihrer StaveNote-`<g>` (Rückgabe von
 * `VexFlowGraphicalNote.getSVGGElement()`).
 *
 * Bei einem **Akkord** teilen sich alle Noten dieselbe StaveNote-`<g>` (VexFlow rendert je Ton ein
 * `<g class="vf-notehead">`, Reihenfolge = aufsteigender Pitch = `vfnoteIndex`). Würde man das ganze
 * `<g>` einfärben, würden **alle** Akkordköpfe rot – deshalb hier nur der Kopf am `vfnoteIndex`.
 *
 * Bei **Einzelnote/Pause** (0 oder 1 `.vf-notehead`) bleibt das bisherige Verhalten: das ganze `<g>`
 * (Kopf + Stem). Liegt `vfnoteIndex` außerhalb der gefundenen Köpfe (sollte nicht vorkommen), wird
 * defensiv der erste Kopf gefärbt.
 *
 * **Warum `vfnoteIndex` == DOM-Reihenfolge der `.vf-notehead` (tragende Annahme, belegt – nicht
 * rückbauen):** Beide Seiten sortieren die Akkordtöne **aufsteigend nach Pitch**, also identisch:
 * OSMD `GraphicalVoiceEntry.sortForVexflow()` sortiert `halfTone_a - halfTone_b` und ruft danach
 * `setIndex(vfnote, i)` in genau dieser Reihenfolge (⇒ `vfnoteIndex 0` = tiefster Ton); VexFlow
 * `StaveNote.calculateKeyProps()` sortiert `keyProps` per `a.line - b.line` (aufsteigend = tiefster
 * zuerst), und `drawNoteHeads()` zeichnet die `note_heads` in dieser Reihenfolge (⇒ erste
 * `<g class="vf-notehead">` im DOM = tiefster Ton). Beide beginnen also beim tiefsten Ton → der
 * `vfnoteIndex`-te Kopf im DOM ist der richtige.
 */
export function selectionTargetElements(g: SVGGElement, vfnoteIndex: number): SVGElement[] {
    const noteheads = g.querySelectorAll<SVGGElement>('.vf-notehead');
    if (noteheads.length > 1) {
        const target = noteheads[vfnoteIndex] ?? noteheads[0];
        if (target) return [...target.querySelectorAll<SVGElement>('path, ellipse, rect')];
    }
    return [...g.querySelectorAll<SVGElement>('path, ellipse, rect')];
}
